import React, { Component } from 'react';
import { StyleSheet, View, Text, Image, Platform, Dimensions } from 'react-native';
import { ThemeColor, Colors } from '@qnpm/q-theme';
import { Button, BUTTON_MAX_WIDTH } from '@qnpm/q-components';
import { statusBarUtil, qAccessibilityLabel, logEvent, QavEvent, commonUtil } from '@qnpm/q-design-utils';
import { Shadow } from '@qnpm/q-shadow';
import { computeBottomPriceAndDays, computeBottomShowData, convertCalendarData } from '../utils/handle';
import { BOTTOM_OTHER_INFO_TEXT, CALENDAR_TYPE, isMiniScreen } from '../utils/constant';
const { scenes: { lrGradientColors } } = Colors;
const isIOS = Platform.OS === 'ios';
const BUTTON_SHADOW_IMG = 'https://s.qunarzz.com/f_cms/2020/1593774578735_138002291.png';
export default class CalendarBottomModule extends Component {
    constructor() {
        super(...arguments);
        this.showData = [];
        /**
         * 点击按钮
         * @param item
         * @param index
         */
        this.clickBtn = (item, index) => {
            const { accessibilityPreName, onClickBottomButton } = this.props;
            const { onClick } = item || {};
            const callBackData = convertCalendarData(this.showData);
            onClick && onClick(callBackData);
            onClickBottomButton && onClickBottomButton(item, index);
            logEvent(new QavEvent({
                page: accessibilityPreName,
                model: 'float_calendar_bottom',
                action: 'click_confirm_button',
                attributes: {
                    operTime: Date.now(),
                    value: callBackData.map((item) => item.value).toString()
                }
            }));
        };
    }
    render() {
        const { adaptFooter, userSelectedDate, selectedPayload, otherInfo = { type: 'price', desc: '' }, mode = CALENDAR_TYPE.SINGLE } = this.props;
        const paddingBottom = 12 + (adaptFooter ? statusBarUtil.getBottomBarHeight() : 0);
        this.showData = computeBottomShowData(selectedPayload, userSelectedDate);
        const { showTextArr, canClick } = computeBottomPriceAndDays(this.showData, otherInfo, mode);
        return (<View style={isIOS ? null : styles.adrShadow}>
                <Shadow shadowPosition="top" style={styles.wrapperShadow}>
                    <View style={[styles.wrapper, { paddingBottom }]}>
                        <View style={styles.topWrapper}>
                            {this.renderTopView(this.showData)}
                            {this.renderOtherInfo(showTextArr, canClick, otherInfo)}
                        </View>
                        <View style={styles.buttonWrapper}>
                            {this.renderButtonsView(canClick)}
                        </View>
                    </View>
                </Shadow>
            </View>);
    }
    /**
     * 渲染顶部视图
     */
    renderTopView(showData) {
        const { mode = CALENDAR_TYPE.SINGLE } = this.props;
        // 是否是多选
        const isMulti = mode === CALENDAR_TYPE.MULTI;
        // 日期等于3则三等份布局，否则距离前一个20px
        const specialStyle = { marginLeft: isMiniScreen ? 8 : 20 };
        const renderContent = () => showData.map((item, index) => {
            const style = !isMulti && index !== 0 ? specialStyle : {};
            const { text, showDate } = item;
            return this.renderTopItem(index, text, showDate, style);
        });
        if (isMulti) {
            return renderContent();
        }
        return <View style={styles.leftWrapper}>{renderContent()}</View>;
    }
    /**
     * 渲染头部左侧视图
     * @param index
     * @param str
     * @param value
     * @param style
     */
    renderTopItem(index, str, value, style) {
        const { accessibilityPreName } = this.props;
        return (<Text key={index + str} {...qAccessibilityLabel(`${accessibilityPreName}BottomLeftTitle#${str}`)} style={[styles.title, styles.fontBold, style ? style : {}]}>
                {str}：
                <Text style={[
            value !== BOTTOM_OTHER_INFO_TEXT
                ? styles.title
                : styles.value
        ]}>
                    {value}
                </Text>
            </Text>);
    }
    /**
     * 渲染头部右侧视图
     * @param showTextArr
     * @param canClick
     * @param otherInfo
     */
    renderOtherInfo(showTextArr, canClick, otherInfo) {
        const { accessibilityPreName } = this.props;
        const { type = '' } = otherInfo || {};
        if (showTextArr.length === 3) {
            return (<View style={styles.otherInfoWrapper} {...qAccessibilityLabel(`${accessibilityPreName}BottomRightTitle#${showTextArr[0]}`)}>
                    <Text style={[styles.title, styles.fontBold]}>
                        {showTextArr[0]}
                    </Text>
                    <Text style={[
                styles.fontBold,
                !canClick
                    ? styles.value
                    : type === 'price'
                        ? styles.orangeValue
                        : styles.title
            ]}>
                        {showTextArr[1]}
                    </Text>
                    <Text style={[styles.title, styles.fontBold]}>
                        {showTextArr[2]}
                    </Text>
                </View>);
        }
        else {
            return null;
        }
    }
    /**
     * 渲染底部按钮
     * @param canClick
     */
    renderButtonsView(canClick) {
        let { buttons, refreshWidth } = this.props;
        refreshWidth = refreshWidth
            ? refreshWidth
            : Dimensions.get('window').width;
        let widthStyle = { width: refreshWidth - 48 };
        if (!commonUtil.isValidArray(buttons)) {
            return null;
        }
        const len = buttons.length;
        return buttons.map((item, index) => {
            const { type, text } = item;
            if (type === 'default') {
                const innerProps = canClick
                    ? {
                        needGradient: true,
                        gradientColors: [
                            lrGradientColors.leftColor,
                            lrGradientColors.rightColor
                        ],
                        onPress: () => {
                            this.clickBtn(item, index);
                        },
                        activeOpacity: 1
                    }
                    : null;
                return (<View key={index} style={[
                    styles.buttonView,
                    index !== 0 ? styles.btnMarginLeft : null
                ]}>
                        {canClick && len === 1 ? (<Image resizeMode="contain" source={{
                    uri: BUTTON_SHADOW_IMG
                }} style={[styles.buttonShadow, widthStyle]}/>) : null}
                        <Button disabled={!canClick} text={text} size={len > 1 ? 'medium' : 'large'} customStyle={StyleSheet.flatten(widthStyle)} {...innerProps}/>
                    </View>);
            }
            else {
                return (<View key={index} style={[
                    styles.buttonView,
                    index !== 0 ? styles.btnMarginLeft : null
                ]}>
                        <Button disabled={!canClick} text={text} size={len > 1 ? 'medium' : 'large'} customStyle={StyleSheet.flatten(widthStyle)} outline={type === 'outlineBtn'} onPress={() => {
                    this.clickBtn(item, index);
                }}/>
                    </View>);
            }
        });
    }
}
const textSize = isMiniScreen ? 13 : 14;
const textHeight = isMiniScreen ? 19 : 20;
const styles = StyleSheet.create({
    wrapper: {
        width: '100%',
        bottom: 0,
        left: 0,
        backgroundColor: '#FFFFFF',
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: isMiniScreen ? 8 : 24,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16
    },
    topWrapper: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginVertical: 16,
        alignItems: 'center',
        width: '100%'
    },
    leftWrapper: {
        flexDirection: 'row'
    },
    title: {
        fontSize: textSize,
        color: ThemeColor.text1,
        lineHeight: textHeight
    },
    value: {
        fontSize: textSize,
        color: ThemeColor.disableText,
        lineHeight: textHeight
    },
    orangeValue: {
        fontSize: textSize,
        color: ThemeColor.price,
        lineHeight: textHeight
    },
    button: {
        width: BUTTON_MAX_WIDTH
    },
    buttonWrapper: {
        width: '100%',
        flexDirection: 'row'
    },
    buttonView: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
    },
    descMarginLeft: {
        marginLeft: 20
    },
    btnMarginLeft: {
        marginLeft: 11
    },
    buttonShadow: {
        width: BUTTON_MAX_WIDTH,
        position: 'absolute',
        top: 22,
        left: 0,
        right: 0,
        height: 32
    },
    disableBtn: {
        backgroundColor: ThemeColor.disableText,
        borderWidth: 0
    },
    fontBold: {
        fontWeight: 'bold'
    },
    adrShadow: {
        paddingTop: 2,
        backgroundColor: 'transparent'
    },
    otherInfoWrapper: {
        flex: 1,
        justifyContent: 'flex-end',
        alignItems: 'center',
        flexDirection: 'row'
    },
    wrapperShadow: {
        shadowOffset: {
            width: 0,
            height: 0
        },
        shadowOpacity: 0.06,
        shadowColor: Colors.palette.gray.shade1,
        shadowRadius: 2
    }
});
